import { Component, Inject } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog'
import { SharedModule } from '@app/shared/shared.module'
import { PipesModule } from '@app/shared/pipe/index.module'
import { ScopeTraffickingService } from '../../service/scope-trafficking.service'
import { IntegrationModalConfig } from '@app/features/scope-overview/model/integration-modal-config'
import { SNACKBAR_LENGTH_SHORT, SnackbarEventType, SnackbarService } from '@shared/utils/snackbar.service'
import { WebsocketService } from '@shared/services/websocket.service'
import { TrafficReportModel, TrafficReportObject } from '@app/features/scope-overview/model/traffic-report-model'
import { ExchangeRateService } from '@shared/services/exchange-rate.service'

@Component({
  selector: 'integration-traffic',
  standalone: true,
  imports: [CommonModule, PipesModule, MatDialogModule, SharedModule],
  templateUrl: './integration-traffic.component.html',
  styleUrls: ['./integration-traffic.component.scss'],
})
export class IntegrationTrafficModal {
  loading = false
  reportMessageList = []

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: IntegrationModalConfig,
    public dialogRef: MatDialogRef<IntegrationTrafficModal>,
    public dialog: MatDialog,
    public traffickingService: ScopeTraffickingService,
    protected snackbarService: SnackbarService,
    protected webSocketService: WebsocketService,
    protected exchangeRateService: ExchangeRateService
  ) {}

  getSelectedIntegrations() {
    return this.data.integrations.filter((int) => int.selected).map((int) => int.apiIntegration.name)
  }

  trafficScope() {
    this.loading = true
    const selectedIntegrationNames = this.getSelectedIntegrations()
    const exchangeRate = this.exchangeRateService.exchangeRate
    this.traffickingService.trafficToIntegration(this.data.scopeId, selectedIntegrationNames, exchangeRate).subscribe({
      next: (response) => {
        const that = this
        this.webSocketService.connect()
        this.webSocketService.registerTrafficReportReceiver(response.subId, function (reportEvent: TrafficReportModel) {
          const reportEventJson = JSON.parse(reportEvent.object)
          const reportObject = reportEventJson as TrafficReportObject
          that.reportMessageList.push(reportObject)
        })
        return response
      },
      error: (error) => {
        console.error(error)
        this.loading = false
        this.snackbarService.showSnackbar(
          `An error occurred during data export`,
          SNACKBAR_LENGTH_SHORT,
          SnackbarEventType.ERROR
        )
      },
    })
  }
}
